import React from 'react';

interface MyApprovalContextConfig {
    refreshCount: Function;
    approvalCount: number | null;
}

export default React.createContext<MyApprovalContextConfig>({
    refreshCount: () => {},
    approvalCount: null,
});
